import i18n from '@/i18n';

export function getFormatLocale(language?: string): string {
  return language?.startsWith('en') ? 'en-US' : 'cs-CZ';
}

export function getAppFormatLocale(): string {
  return getFormatLocale(i18n.language);
}

export function getNumberSuffixes(language?: string): { thousand: string; million: string; billion: string } {
  if (language?.startsWith('en')) {
    return { thousand: 'k', million: 'm', billion: 'b' };
  }

  return { thousand: 'tis.', million: 'mil.', billion: 'mld.' };
}
